import { useLocation } from 'react-router-dom';
import {
  Grid, Container, Typography,
  Stack,
} from '@mui/material';
import ActiveUsersMore from '../modules/Accounts/components/ActiveUsers/ActiveUsersMore';
import { usePackages } from '../hooks/usePackages';
import { SelectBox } from '../components/FormComponents';
import useStyles from '../hooks/useStyles';
import styles from '../layouts/pages/style';
import Metatags from '../components/MetaTags/MetaTags';
import useActiveUsers from '../modules/Accounts/components/ActiveUsers/useActiveUsers';
import useToggle from '../hooks/useToggle';

const activeUsersData = [
  { id: 1, title: 'Monthly Active Users', range: 'monthData' },
  { id: 2, title: 'Weekly Active Users', range: 'weekData' },
  { id: 3, title: 'Daily Active Users', range: 'dayData' },
];

export default function ActiveUsersMorePage() {
  const location = useLocation();
  const accountName = location.state && location.state.accountName;
  const accountId = location.state ? location.state.accountId : 'all';
  const page = location.state ? location.state.page : 'dashboard';
  const [refreshUsers, setRefreshUsers] = useToggle();

  const { packageList, selectedPackage, handlePackageChange } = usePackages({ defaultSelected: '-all-' });
  const activeUsers = useActiveUsers({
    page, accountId, packageId: selectedPackage, refreshUsers,
  });
  const classes = useStyles(styles)();

  return (
    <>
      <Metatags metaTagName="Engagement | ISV Insights " />

      <Container maxWidth="xl">
        <Grid container gap={2}>
          <Grid item xs={12} className={classes.cardStyles}>
            <Stack spacing={2} direction="row" alignItems="center" justifyContent="space-between">
              <Typography variant="h4">
                {`Engagement${accountId && accountId !== 'all' ? ` - ${accountName || accountId}` : ''}`}
              </Typography>

              <SelectBox
                title="Package"
                height="35px"
                width="200px"
                value={selectedPackage}
                data={packageList}
                onChange={handlePackageChange}
              />
            </Stack>
          </Grid>

          <Grid container spacing={3}>
            {activeUsersData.map(({ id, title, range }) => (
              <Grid item lg={12} key={id}>
                <ActiveUsersMore
                  title={title}
                  error={activeUsers.error}
                  loading={activeUsers.loading}
                  data={activeUsers[range]}
                  viewOption={range}
                  setRefresh={setRefreshUsers}
                />
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
